import "vanilla-cookieconsent/dist/cookieconsent.css";
import CookieConsent from "vanilla-cookieconsent/dist/cookieconsent.umd.js";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Set default consent to 'denied' (this should happen before changing any other dataLayer)
gtag('consent', 'default', {
    [SERVICE_AD_STORAGE]: 'granted',
    [SERVICE_AD_USER_DATA]: 'granted',
    [SERVICE_AD_PERSONALIZATION]: 'granted',
    [SERVICE_ANALYTICS_STORAGE]: 'granted',
    [SERVICE_FUNCTIONALITY_STORAGE]: 'granted',
    [SERVICE_PERSONALIZATION_STORAGE]: 'granted',
    [SERVICE_SECURITY_STORAGE]: 'granted',
});

/**
 * Update gtag consent according to the users choices made in CookieConsent UI
 */
function updateGtagConsent() {
    gtag('consent', 'update', {
        [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
        [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
    });
}

CookieConsent.run({
    onFirstConsent: () => {
        updateGtagConsent();
        window.dataLayer.push({'event': 'cc_first_consent'});
    },
    onConsent: () => {
        updateGtagConsent();
        window.dataLayer.push({'event': 'cc_consent'});
    },
    onChange: () => {
        updateGtagConsent();
        window.dataLayer.push({'event': 'cc_change'});
    },
    guiOptions: {
        consentModal: {
            layout: "bar",
            position: "bottom",
            equalWeightButtons: false,
            flipButtons: true
        },
        preferencesModal: {
            layout: "bar wide",
            position: "right",
            equalWeightButtons: false,
            flipButtons: true
        }
    },
    categories: {
        [CAT_NECESSARY]: {
            enabled: true,  // this category is enabled by default
            readOnly: true,  // this category cannot be disabled
        },
        [CAT_ANALYTICS]: {
            autoClear: {
                cookies: [
                    {
                        name: /^(_ga)/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    },
                    {
                        name: /^(_hj)/ // Hotjar
                    },
                ]
            },
            // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                [SERVICE_ANALYTICS_STORAGE]: {
                    label: 'Enables storage (such as cookies) related to analytics e.g. visit duration.',
                }
            }
        },
        [CAT_ADVERTISEMENT]: {
            autoClear: {
                cookies: [
                    {
                        name: /^(_gcl_au)/ // Google Adsense
                    },
                    {
                        name: /^(_fbp)/ // Facebook Pixel
                    },
                    {
                        name: /^(__kla_id)/ // Klaviyo
                    },
                ]
            },
            services: {
                [SERVICE_AD_STORAGE]: {
                    label: 'Enables storage (such as cookies) related to advertising.',
                },
                [SERVICE_AD_USER_DATA]: {
                    label: 'Sets consent for sending user data related to advertising to Google.',
                },
                [SERVICE_AD_PERSONALIZATION]: {
                    label: 'Sets consent for personalized advertising.',
                },
            }
        },
        [CAT_FUNCTIONALITY]: {
            services: {
                [SERVICE_FUNCTIONALITY_STORAGE]: {
                    label: 'Enables storage that supports the functionality of the website or app e.g. language settings.',
                },
                [SERVICE_PERSONALIZATION_STORAGE]: {
                    label: 'Enables storage related to personalization e.g. video recommendations.',
                },
            }
        },
        [CAT_SECURITY]: {
            services: {
                [SERVICE_SECURITY_STORAGE]: {
                    label: 'Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.',
                },
            }
        },
    },
    language: {
        default: "nl",
        autoDetect: "document",
        translations: {
            nl: {
                consentModal: {
                    title: 'Deze website gebruikt cookies',
                    description: 'Door op "Accepteren" te klikken gaat u ermee akkoord dat onze cookies op uw computer worden opgeslagen. Hierdoor kunnen wij u een betere gebruikerservaring bieden en het gebruik van de website analyseren. Door te klikken op "Voorkeuren beheren" kunt u kiezen welke cookies u toestaat. Alleen de essentiële cookies zijn nodig voor een goede werking van de website en u kunt deze niet weigeren.',
                    acceptAllBtn: 'Accepteren',
                    acceptNecessaryBtn: 'Afwijzen',
                    showPreferencesBtn: 'Voorkeuren beheren',
                    footer: "<a href=\"/privacy-policy\">Privacybeleid</a>\n<a href=\"/algemene-voorwaarden\">Algemene voorwaarden</a>"
                },
                preferencesModal: {
                    title: 'Cookie voorkeuren',
                    acceptAllBtn: 'Accepteren',
                    acceptNecessaryBtn: 'Afwijzen',
                    savePreferencesBtn: 'Voorkeuren opslaan',
                    closeIconLabel: 'Sluiten',
                    sections: [
                        {
                            description: "Onze website bewaart drie soorten cookies. Je kan zelf op elk moment kiezen welke je aanvaardt en welke niet. Meer informatie over wat cookies zijn en welke types cookies we verzamelen kan je lezen in ons <a href=\"/cookie-beleid\">cookiebeleid</a>."
                        },
                        {
                            title: "Strikt noodzakelijke cookies <span class=\"pm__badge\">Altijd ingeschakeld</span>",
                            description: "Deze cookies zijn noodzakelijk voor de goede werking van de website en verzamelen geen persoonlijke gegevens.",
                            linkedCategory: CAT_NECESSARY,
                        },
                        {
                            title: "Analytische",
                            description: 'Met analytische cookies kunnen we het gebruik van de website analyseren en de bezoekerservaring verbeteren.',
                            linkedCategory: CAT_ANALYTICS,
                            cookieTable: {
                                headers: {
                                    name: "Name",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "Expires after 12 days"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Advertentie',
                            description: 'Google gebruikt cookies voor advertenties, waaronder het weergeven en weergeven van advertenties, het personaliseren van advertenties (afhankelijk van uw advertentie-instellingen op <a href=“https://g.co/adsettings”>g.co/adsettings</a>), het beperken van het aantal keren dat een advertentie wordt weergegeven aan een gebruiker, het dempen van advertenties die u niet meer wilt zien en het meten van de effectiviteit van advertenties.',
                            linkedCategory: CAT_ADVERTISEMENT,
                        },
                        {
                            title: 'Functionaliteit',
                            description: 'Cookies die worden gebruikt voor functionaliteit stellen gebruikers in staat om te communiceren met een dienst of site om toegang te krijgen tot functies die fundamenteel zijn voor die dienst. Zaken die als fundamenteel voor de service worden beschouwd, zijn voorkeuren zoals de taalkeuze van de gebruiker, productoptimalisaties die helpen bij het onderhouden en verbeteren van een service en het bijhouden van informatie met betrekking tot de sessie van een gebruiker, zoals de inhoud van een winkelwagentje.',
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: 'Beveiliging',
                            description: 'Cookies die worden gebruikt voor beveiliging verifiëren gebruikers, voorkomen fraude en beschermen gebruikers tijdens hun interactie met een service.',
                            linkedCategory: CAT_SECURITY,
                        },
                        {
                            title: 'Meer informatie',
                            description: 'Als u vragen hebt over het beleid inzake cookies en uw keuzes, <a href=“/contact”>contacteer ons</a>.'
                        }
                    ]
                }
            },
            en: {
                consentModal: {
                    title: 'This website uses cookies',
                    description: 'By clicking \"Accept all\" you agree to have our cookies stored on your computer. This allows us to provide a better user experience, and it allows us to analyze the use of the website.\n\nBy clicking \"Manage your preferences\" you can choose which cookies you allow. Only the essential cookies are necessary for the proper functioning of the website and you cannot refuse them.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                    footer: "<a href=\"/privacy-policy\">Privacy Policy</a>\n<a href=\"/terms-and-conditions\">Terms and conditions</a>"
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save preferences',
                    closeIconLabel: 'Close',
                    sections: [
                        {
                            description: "Our website stores three types of cookies. You can choose at any time which ones you accept and which ones you do not. You can learn more about what cookies are and what types of cookies we collect in our <a href=\"/cookie policy\">cookie policy</a>."
                        },
                        {
                            title: "Strictly necessary cookies <span class=\"pm__badge\">Always active</span>",
                            description: "These cookies are necessary for the proper functioning of the website and do not collect personal data.",
                            linkedCategory: CAT_NECESSARY,
                            cookieTable: {
                                headers: {
                                    name: "Name",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "CRAFT_CSRF_TOKEN",
                                        domain: "Website",
                                        description: "Used by the Content Management System to prevent cyber attacks. This cookie is essential for website and visitor security.",
                                        expiration: "Expires after one session"
                                    },
                                    {
                                        name: "CraftSessionId",
                                        domain: "Website",
                                        description: "Used by the CMS to create a unique ID for the visitor.",
                                        expiration: "Expires after one session"
                                    },
                                ]
                            }
                        },
                        {
                            title: "Analytics",
                            description: 'Cookies used for analytics help collect data that allows services to understand how users interact with a particular service. These insights allow services both to improve content and to build better features that improve the user’s experience.',
                            linkedCategory: CAT_ANALYTICS,
                            cookieTable: {
                                headers: {
                                    name: "Name",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "Expires after 12 days"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Advertising',
                            description: 'Google uses cookies for advertising, including serving and rendering ads, personalizing ads (depending on your ad settings at <a href=\"https://g.co/adsettings\">g.co/adsettings</a>), limiting the number of times an ad is shown to a user, muting ads you have chosen to stop seeing, and measuring the effectiveness of ads.',
                            linkedCategory: CAT_ADVERTISEMENT,
                        },
                        {
                            title: 'Functionality',
                            description: 'Cookies used for functionality allow users to interact with a service or site to access features that are fundamental to that service. Things considered fundamental to the service include preferences like the user’s choice of language, product optimizations that help maintain and improve a service, and maintaining information relating to a user’s session, such as the content of a shopping cart.',
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: 'Security',
                            description: 'Cookies used for security authenticate users, prevent fraud, and protect users as they interact with a service.',
                            linkedCategory: CAT_SECURITY,
                        },
                        {
                            title: 'More information',
                            description: 'For any queries in relation to the policy on cookies and your choices, please <a href="/contact">contact us</a>.'
                        }
                    ]
                }
            }
        }
    },
    disablePageInteraction: true
});
